<div class="container mt-5">
    <div class="row">
        <div class="col-md-12">

            <div class="d-flex justify-content-center small-margin-top" *ngIf="isLoading.loadingListTerritories">
                <zint-loader></zint-loader>
            </div>

            <div id="saved-searches-tab" *ngIf="!isLoading.loadingListTerritories" >

                <h2 class="small-margin-top">Territories:</h2>

                <h5 class="medium-margin-top" *ngIf="territories">Organisation Territories:</h5>
                <p class="small-margin-top" *ngIf="!territories || territories.length == 0">There are no territories associated with your account.</p>
                <p class="small-margin-top">Note that if you enforce a territory, every user that this territory is shared with will only be able to search within that territory. This may significantly reduce search results for these users. If a user is affected by more than one enforced territory, only the first enforced territory will be imposed on their searches and others will be ignored.</p>

                <table *ngIf="territories && territories.length > 0" class="table table-striped table-bordered small-margin-top" style="table-layout:fixed;">
                    <thead>
                        <tr>
                            <td>Territory Name</td>
                            <td style="width: 40%">Parameters</td>
                            <td colspan="2">Users and Teams Shared With</td>
                            <td>Enforced?</td>
                            <td>Delete</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let territory of territories">
                            <td>{{ territory.name }}</td>
                            <td>
                                <div class="overflow-auto"> <search-parameters [inputParams]="{'searchTags': territory.searchParams, 'enableClearing': false}"></search-parameters> </div>
                            </td>
                            <!-- Add users to territory -->
                            <td colspan="2">
                                <zint-permissions
                                    [allUsers]="organisationUsersAndTeams.organisation_users"
                                    [allTeams]="organisationUsersAndTeams.organisation_teams"
                                    [existingTeams]="territory.organisations_viewable_by"
                                    [existingUsers]="territory.users_viewable_by"
                                    (onPermissionChange)="handlePermissionsChange($event, territory.id)"
                                ></zint-permissions>
                            <td>
                            <input type="checkbox"
                               [attr.disabled]="isLoading.loadingTogglingTerritoryEnforcement ? 'disabled': null"
                               [(ngModel)]="territory.is_enforced"
                               (ngModelChange)="updateTerritoryEnforcement(territory)"/>
                            </td>
                            <td><button class="rounded-btn-base button-dark" (click)="confirmDelete(territory.id)"><i class="fal fa-trash"></i></button></td>
                        </tr>
                    </tbody>
                </table>

            </div>

        </div>
    </div>
</div>

@if (showDeleteModal) {
    <zint-modal
        [modalConfig]="modalConfig"
        [modalContent]="modalContent"
        (onConfirm)="deleteTerritory()"
        (onDismiss)="territoryIdToDelete = null;"
    >
    <mark modalContent>This will delete this territory and consequently, the users and teams shared, will no longer have access to it.</mark>
    </zint-modal>
}
